import React, { useState } from 'react';
import { CheckCircleOutlined, ClockCircleOutlined, DownOutlined, ExclamationCircleOutlined, LogoutOutlined, SettingOutlined, StarOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import AppSecureStorage from '../../services/storage/secureStorage';
import { setLoggedInUser } from '../../features/Auth/authSlice';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '../../utils/authHelpers';
import { setAllSubscription, setLatestSubscriptions } from '../../features/UserInfo/UserSlice';
import { setAllSubscriptionorg, setLatestSubscriptionsorg } from '../../features/Organization/OrganizationInfo/OrganizationSlice';
import SubscriptionSection from '../../pages/Organizations/Subscriptions/SubscriptionsSection';
import JobSeekerSubscription from '../CommonElements/JobSeekerSubscription';
import PricingComponent from '../../pages/GuestUsers/PricingComponent';

const ProfileCard = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const storage = new AppSecureStorage()
  let currentUser = getCurrentUser()
  const { userProfile } = useSelector((state) => state.global);
  const [subscription, setSubscription] = useState(userProfile?.subscription);
  const [issubscriptionJob, setIsSubscriptionJob] = useState(false);
  const [issubscription, setIsSubscription] = useState(false)

  const handleLogout = () => {
    dispatch(setLoggedInUser(null))
    dispatch(setAllSubscription([]))
    dispatch(setLatestSubscriptions([]))
    dispatch(setAllSubscriptionorg([]))
    dispatch(setLatestSubscriptionsorg([]))
    storage.clearStorage();
    navigate('/');
  };

  const naviagteSetting = currentUser === 'organization' ? '/organization-settings' : '/jobseeker/setting'
  const naviagteProfile = currentUser === 'organization' ? '/organization-info' : '/jobseeker/user-info'
  let activeAvatar = currentUser === 'organization' ? userProfile?.orgLogo : userProfile?.avatar

  const items = [
    {
      key: 'profile',
      label: (
        <div className='flex-space-between-gap-20 fullwidth'>
          <div className='fullwidth'>My Profile</div>
          <Avatar
            style={{ width: '35px', height: '25px' }}
            size={'default'}
            shape='circle'
            icon={!userProfile?.avatar && <UserOutlined />}
            src={activeAvatar}
          />
        </div>
      ),
      onClick: () => navigate(naviagteProfile),
    },
    { type: 'divider' },
    {
      key: 'settings',
      label: (
        <div className='flex-space-between-gap-20 fullwidth'>
          <div className='fullwidth'>Setting</div>
          <SettingOutlined />
        </div>
      ),
      onClick: () => navigate(naviagteSetting),
    },
    { type: 'divider' },
    ...(currentUser === 'employee'
      ? [
        {
          key: 'help-center',
          label: (
            <div className='flex-space-between-gap-20 fullwidth'>
              <div className='fullwidth'>Help Center</div>
              <ExclamationCircleOutlined />
            </div>
          ),
          onClick: () => navigate('/help-center'),
        },
        { type: 'divider' }, 
      ]
      : []),
    {
      key: 'logout',
      label: (
        <div className='flex-space-between-gap-20 fullwidth'>
          <div className='fullwidth'>Logout</div>
          <LogoutOutlined />
        </div>
      ),
      onClick: handleLogout,
    },

  ];


  const truncatedName = userProfile?.name?.length > 8
    ? `${userProfile.name.slice(0, 6)}...`
    : userProfile?.name;


  return (
    <>
      <Dropdown
        menu={{ items }}
        trigger={['click']}
      >
        <a onClick={(e) => e.preventDefault()}>
          <Space>
            <Avatar className='text-white' size={'small'} icon={!userProfile?.avatar && <UserOutlined />} src={activeAvatar} />
            <div className='text-white'>{truncatedName}</div>
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
      <PricingComponent
        visible={
          currentUser === 'organization'
            ? issubscription
            : issubscriptionJob

        }
        onClose={() => {
          if (currentUser === 'organization') return setIsSubscription(false);
          return setIsSubscriptionJob(false);
        }}
      />
    </>
  );
}

export default ProfileCard;